module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "features"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mockup-container",
    class: {
      'is-fixed': _vm.fixed
    },
    style: ({
      top: _vm.position
    })
  }, [_c('mobile-mockup', _vm._l((_vm.features), function(feature, index) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex === index),
        expression: "currentIndex === index"
      }],
      attrs: {
        "src": feature.screenshootSrc,
        "alt": ""
      }
    })
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a861876","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileDemo.vue
// module id = 109
// module chunks = 0